import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-small-card-clickable',
  templateUrl: './small-card-clickable.component.html',
  imports: [TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallCardClickableComponent {
  cardTitle = input.required<string>();
  testId = input<string>('');
  cardClicked = output();
}
